export default __webpack_public_path__ + "static/scrollable_popup-d9a36556eb0df63b19302a342ac241b9.png";